import React from "react";
import { observer } from "mobx-react";
import { Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { RouteComponentProps, withRouter } from "react-router-dom";


type Props = RouteComponentProps<any>;

@observer
export class KassesLayoutComponent extends React.Component<Props, any> {

    render() {
        return <div>
            <Nav variant="tabs" defaultActiveKey="/kassesmanagement/kasses" activeKey={this.props.location.pathname}>
                <LinkContainer to="/kassesmanagement/kasses">
                    <Nav.Item>
                        <Nav.Link href="/kassesmanagement/kasses">Кассы</Nav.Link>
                    </Nav.Item>
                </LinkContainer>
                {this.props.location.pathname.indexOf("/kassesmanagement/kassa") > -1 ? <Nav.Item >
                    <Nav.Link href={this.props.location.pathname}>Детали кассы</Nav.Link>
                </Nav.Item> : []}
            </Nav>

            <div>
                {this.props.children}
            </div>
        </div >;
    }
}

const KassesLayout = withRouter(KassesLayoutComponent)
export default KassesLayout;